import styled from "@emotion/styled/macro";
import Cleave from "cleave.js/react";

const StyledCleave = styled<any, { isValid?: boolean; center: boolean }>(
  Cleave,
  {
    shouldForwardProp: prop => {
      return prop !== "isValid" && prop !== "center";
    }
  }
)`
  padding: 7px 16px;
  border-radius: 10px;
  background: ${({ isValid = true }) => (isValid ? "#ccd0da" : "#cb3d3d")};
  color: ${({ isValid = true }) => (isValid ? "inherit" : "#fff")};
  border: 1px solid transparent;
  width: 100%;
  text-align: ${({ center }) => (center ? "center" : "left")};

  &:focus {
    border-color: inherit;
    outline: none;
  }
`;

export default StyledCleave;
